import * as React from 'react';
export const NCSvg = React.forwardRef(function NCSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#217AB7',
        d: 'M1.994 2A1.992 1.992 0 0 0 0 4v2h16V4c0-1.105-.895-2-1.994-2H1.994Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M0 6h16v4H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#24B47E',
        d: 'M0 10v2c0 1.105.895 2 1.994 2h12.012A1.992 1.992 0 0 0 16 12v-2H0Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FCD669',
        fillRule: 'nonzero',
        d: 'M5 5a3 3 0 1 1 0 6 3 3 0 0 1 0-6Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#333',
        fillRule: 'nonzero',
        d: 'M5 6a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm0-1a3 3 0 1 1 0 6 3 3 0 0 1 0-6Z',
      }),
    ),
  );
});
NCSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var NC = {
  category: 'flag',
  colorable: false,
  name: 'NC',
  svg: NCSvg,
};
